// app/routes/login.js
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LoginRoute extends Route {
  @service session;

  beforeModel(transition) {
    console.log('in the beforeModel for the LoginRoute')
    this.session.prohibitAuthentication('authenticated');
  }
}
